// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".is-danger[data-v-2eb54c12]{background-color:#ff3860!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
